define('models/pages/requests/table',['require','underscore','chaplin','./table-row','models/base/collection','lib/utils'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        TableRowModel = require('./table-row'),
        Collection = require('models/base/collection'),
        utils = require('lib/utils');

    var TableModel = Collection.extend({
        urlPath: '/api/request-group',
        model: TableRowModel,
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        },
        urlParams: function() {
            var params = Collection.prototype.urlParams.apply(this, arguments);

            params.fromDate = this.fromDate;
            params.toDate = this.toDate;

            return params;
        }
    });

    return TableModel;
});
